<template>
  <header class="Top-Bar">
    <img class="Logo" src="@/assets/deonelectronics.png" alt="Deon Electronics Logo" @click="$router.push('/')">
    <h1 class="brand-name" @click="$router.push('/')">deon electronics®</h1>
    <h2 class="contact-link">Contact</h2>
  </header>
  <div class="subTopBar">
    <h2>deon electronics powering your digital dreams</h2>
  </div>
  <router-view/>
  <!-- Footer -->
  <footer class="Footer" id="contact">
    <div>
      © 2025 DeonElectronics — contact@deonelectronics.fr
    </div>
  </footer>
</template>

<script>

</script>

<style>
@font-face {
  font-family: "deonstudio";
  src: url("@/assets/Fonts/deonstudio.otf") format("opentype");
}

/* Variables CSS globales pour tout le site */
:root {
  /* Couleurs échiquier */
  --svg-board-bg: #f8f9fa; /* couleur case blanche */
  --svg-board-bc: #d30000; /* couleur case noir */
  /* Couleurs principales */
  --primary-red: red; /* Rouge principal */
  --primary-red-dark: #ac0000; /* Rouge foncé (pour les hovers, etc.) */
  --primary-red-light: #f26a44; /* Rouge clair (pour les accents) */

  /* Couleurs de fond */
  --bg-primary: #f8f9fa; /* Blanc cassé pour le fond principal */
  --bg-secondary: #1E1E20; /* Gris foncé pour header/footer */
  --bg-tertiary: #ffffff; /* Blanc pur pour les cartes */
  --bg-card: #ffffff; /* Blanc pour les cartes */

  /* Couleurs de texte */
  --text-primary: #FAFDF6; /* Blanc pour header */
  --text-red: red; /* Rouge pour les titres */
  --text-secondary: #333333; /* Gris foncé pour le texte principal */
  --text-muted: #666666; /* Gris moyen pour le texte secondaire */
  --text-link: #0066cc; /* Bleu pour les liens */

  /* Couleurs des cards */
  --primary-white: #ffffff;
  --card-border: #e0e0e0; /* Bordure grise claire */

  /* Couleurs d'accent */
  --accent-green: #28a745; /* Vert pour les succès */
  --accent-blue: #0066cc; /* Bleu pour les liens */
  --accent-white: #ffffff; /* Blanc pur */

  /* Couleurs avec transparence */
  --primary-red-alpha-10: rgba(228, 77, 38, 0.1);
  --primary-red-alpha-20: rgba(228, 77, 38, 0.2);
  --primary-red-alpha-30: rgba(228, 77, 38, 0.3);
  --primary-red-alpha-40: rgba(228, 77, 38, 0.4);
  --primary-red-alpha-50: rgba(228, 77, 38, 0.5);
  --primary-red-alpha-60: rgba(228, 77, 38, 0.6);
  --primary-red-alpha-80: rgba(228, 77, 38, 0.8);

  --green-alpha-10: rgba(40, 167, 69, 0.1);
  --green-alpha-20: rgba(40, 167, 69, 0.2);
  --green-alpha-30: rgba(40, 167, 69, 0.3);
  --green-alpha-40: rgba(40, 167, 69, 0.4);
  --green-alpha-50: rgba(40, 167, 69, 0.5);

  --white-alpha-10: rgba(255, 255, 255, 0.1);
  --white-alpha-20: rgba(255, 255, 255, 0.2);
  --white-alpha-30: rgba(255, 255, 255, 0.3);

  --black-alpha-10: rgba(0, 0, 0, 0.1);
  --black-alpha-20: rgba(0, 0, 0, 0.2);
  --black-alpha-30: rgba(0, 0, 0, 0.3);
  --black-alpha-40: rgba(0, 0, 0, 0.4);
  --black-alpha-50: rgba(0, 0, 0, 0.5);
  --black-alpha-80: rgba(0, 0, 0, 0.8);

  /* Bordures */
  --border-primary: 1px solid var(--card-border);
  --border-secondary: 1px solid var(--primary-red-alpha-30);
  --border-accent: 4px solid var(--primary-red);
  --border-hover: 1px solid var(--primary-red);

  /* Rayons de bordure */
  --radius-small: 4px;
  --radius-medium: 8px;
  --radius-large: 12px;
  --radius-xl: 16px;

  /* Transitions */
  --transition-fast: 0.2s ease;
  --transition-normal: 0.3s ease;
  --transition-slow: 0.5s ease;

  /* Espacements */
  --spacing-xs: 0.5rem;
  --spacing-sm: 1rem;
  --spacing-md: 1.5rem;
  --spacing-lg: 2rem;
  --spacing-xl: 3rem;
  --spacing-xxl: 4rem;
}

/* Base styles */
/* * {
  box-sizing: border-box;
} */

body {
  margin: 0;
  width: 100%;
  justify-content: center;
  background-color: var(--bg-primary);
  color: var(--text-secondary);
  font-family: 'Montserrat', Arial, sans-serif;
  min-height: 100vh;
}

#app {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  margin: 0;
}

/* Header */
.Top-Bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  
  height: 80px;
  width: 100% !important;
  
  margin: auto;
  padding: 0 !important;
  background: var(--bg-secondary);
  position: relative;
  z-index: 1;
}

.Logo {
  margin: 5%;
  padding: auto;
  height: 60px;
  min-height: 40px;
  max-height: 80px;
  flex-shrink: 0;
  z-index: 999;
  transition: filter var(--transition-normal);
}

.Logo:hover {
  filter: brightness(1.1);
}

h1 {
  font-family: deonstudio;
  margin: 0;
  padding: 0;
  font-size: 2rem !important;
}

.doText {
  font-family: 'Fira Mono', monospace !important;
  color: var(--accent-green) !important;
  padding: auto;
}

.brand-name {
  position: absolute;
  cursor: pointer;
  text-decoration: none;
  margin: auto;
  width: 100vw;
  text-align: center;
  font-size: 1rem;
  color: var(--text-primary);
  z-index: 1;


}

.contact-link {
  margin: 5%;
  padding: auto;
  font-family: deonstudio;
  font-size: 1rem;
  cursor: pointer;
  color: var(--accent-white);
  background: var(--primary-red);
  padding: 0.6rem 1.5rem;
  border-radius: var(--radius-small);
  font-weight: 600;
  transition: all var(--transition-normal);
  z-index: 50;

}

.contact-link:hover {
  background: var(--primary-red-dark);
  transform: translateY(-1px);
}

/* Sub header */
.subTopBar {
  margin: auto;
  background: var(--primary-red);
  width: 100%;
  min-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--accent-white);
  font-family: deonstudio;
  padding: 0 !important;
  position: relative;
  
}

.subTopBar h2 {
  font-size: 1rem;
  margin: auto;
  text-align: center;
  letter-spacing: 1px;
}

/* Footer */
.Footer {
  width: 100%;
  background: var(--bg-secondary);
  color: var(--text-primary);
  text-align: center;
  padding: var(--spacing-lg) var(--spacing-sm) var(--spacing-md) var(--spacing-sm);
  font-size: clamp(0.8rem, 2vw, 1rem);
  margin-top: auto;
  border-top: var(--border-accent);
  font-family: deonstudio;
  position: relative;
}

/* Responsive styles restent identiques... */
@media (max-width: 1024px) {
  .Top-Bar {
    padding: 0 var(--spacing-md);
    height: 70px;
  }
  
  .Logo {
    height: 50px;
  }
  
  .contact-link {
    padding: 0.5rem 1.2rem;
  }
}

@media (max-width: 768px) {
  .Top-Bar {
    flex-direction: column;
    height: auto;
    padding: var(--spacing-sm);
    gap: var(--spacing-sm);
  }
  
  .Logo {
    height: 50px;
    order: 1;
  }
  
  .brand-name {
    order: 2;
    font-size: 1.5rem;
    text-align: center;
  }
  
  .contact-link {
    order: 3;
    font-size: 1rem;
    padding: 0.7rem var(--spacing-lg);
  }
  
  .subTopBar {
    padding: var(--spacing-sm);
    min-height: 50px;
  }
  
  .Footer {
    padding: var(--spacing-md) var(--spacing-sm);
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .Top-Bar {
    padding: 0.8rem;
    gap: 0.8rem;
  }
  
  .brand-name {
    font-size: 1.3rem;
  }
  
  .contact-link {
    font-size: 0.9rem;
    padding: 0.6rem var(--spacing-md);
  }
  
  .subTopBar h2 {
    font-size: 0.8rem;
    padding: 0 var(--spacing-xs);
  }
}

@media (min-width: 1200px) {
  .Top-Bar {
    padding: 0 var(--spacing-xxl);
    height: 90px;
  }
  
  .Logo {
    height: 70px;
  }
  
  .brand-name {
    font-size: 2.2rem;
  }
  
  .contact-link {
    font-size: 1.3rem;
    padding: 0.8rem var(--spacing-lg);
  }
}

@media (min-width: 1600px) {
  .Top-Bar {
    padding: 0 6rem;
  }
  
  .subTopBar {
    padding: var(--spacing-sm) var(--spacing-lg);
  }
}
</style>